var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file    下拉二级导航
 * @author (wangzichuan)
 */
import React, { Component } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import NavbarDropdown from './NavbarDropdown';
import './NavbarMulti.less';
import { classPrefix } from '../../common/util';
/*
 *  参数说明
 *  dataSource          必需，数据源，对象数组
 *  selectedKeys        可选，默认选中，字符串数组
 *  className           可选，传入类自定义，字符串
 *  classPrefix         可选，类名前缀
 */

var NavbarMulti = function (_Component) {
    _inherits(NavbarMulti, _Component);

    function NavbarMulti() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, NavbarMulti);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NavbarMulti.__proto__ || Object.getPrototypeOf(NavbarMulti)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            dropdownData: null
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(NavbarMulti, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                classPrefix = _props.classPrefix,
                dataSource = _props.dataSource,
                selectedKeys = _props.selectedKeys;

            var cx = classnames(className, _defineProperty({}, classPrefix + '-navbar-content', true));
            var dropdownCls = classnames(className, _defineProperty({}, classPrefix + '-navbar-multi-dropdown', true));
            return React.createElement(
                'ul',
                { className: cx },
                dataSource.map(function (item) {
                    var licls = classnames({
                        'navbar-multi-content-li': true,
                        'navbar-multi-content-li-active': item.key === selectedKeys[0],
                        'navbar-multi-content-li-has-children': item.children
                    });
                    return React.createElement(
                        'li',
                        { key: item.key, className: licls },
                        item.content,
                        item.children && React.createElement(NavbarDropdown, {
                            className: dropdownCls,
                            dataSource: item.children
                        })
                    );
                })
            );
        }
    }]);

    return NavbarMulti;
}(Component);

NavbarMulti.propTypes = {
    className: PropTypes.string,
    classPrefix: PropTypes.string,
    dataSource: PropTypes.array,
    selectedKeys: PropTypes.array
};
NavbarMulti.defaultProps = {
    classPrefix: classPrefix,
    dataSource: [],
    selectedKeys: []
};
export default NavbarMulti;